import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsHandcycleNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#sports_handcycle_normal_large_svg__clip0_138_67)">
        <path
          d="M42.02 20.99a5.988 5.988 0 00-4.75 2.34l-9.28-4.94c.008-.06.012-.12.01-.18a3 3 0 10-1.797 2.75c.38-.168.719-.413.997-.72l5.77 3.07L31.42 26H20.15a2.539 2.539 0 01-2.25-1.35L14.37 18h-2.26l4.02 7.58c.163.303.36.584.59.84A4.59 4.59 0 0020.15 28h12.43l2.16-3.75 1.58.84a6.01 6.01 0 105.7-4.1zM24 18.21a1 1 0 111.999 0 1 1 0 01-2 0zm18.02 12.8A4.016 4.016 0 0138.01 27c-.002-.32.039-.64.12-.95l3.84 2.05v-2.27l-2.89-1.54a3.973 3.973 0 012.94-1.3 4.01 4.01 0 010 8.02zM11.93 26a6.01 6.01 0 100 2h3.37l-1.07-2h-2.3zm-2.04 2a4.01 4.01 0 110-2H6.02v2h3.87z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="sports_handcycle_normal_large_svg__clip0_138_67">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsHandcycleNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsHandcycleNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsHandcycleNormalLarge;
